import * as React from "react";
const VolumeHighSvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
  >
    <rect
      width="31.564"
      height="31.564"
      x="0.218"
      y="0.218"
      fill="#fff"
      rx="15.782"
    ></rect>
    <rect
      width="31.564"
      height="31.564"
      x="0.218"
      y="0.218"
      stroke="#676C6F"
      strokeWidth="0.436"
      rx="15.782"
    ></rect>
    <path
      stroke="#676C6F"
      strokeWidth="0.727"
      d="M9.333 14.667v2.666q0 2 2 2h.954c.246 0 .493.074.706.2l1.947 1.22c1.68 1.054 3.06.287 3.06-1.693v-6.12c0-1.987-1.38-2.747-3.06-1.693l-1.947 1.22c-.213.126-.46.2-.706.2h-.954q-2 0-2 2Z"
    ></path>
    <path
      stroke="#676C6F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.727"
      d="M20 13.333a4.44 4.44 0 0 1 0 5.334M21.22 11.667a7.22 7.22 0 0 1 0 8.666"
    ></path>
  </svg>
);
export default VolumeHighSvgIcon;
